// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  release: '20260325-054443',
  production: false
};



// WEBPACK FOOTER //
// D:/github/490/rec_ng_recibopago490v7/src/environments/environment.ts